module.exports = __webpack_public_path__ + "img/a3.f6dc73f2.jpg";